/* eslint-disable */
/**
 * @module ParseEmoteOutput
 * Last updated 1/30/25
 * Added export default to end of file; update _apiUrl to work w/app.mfc
 * Added darkMode support (Kiran 12/17/24)
 * eslint-disable
 * update equality checks
 */
// ajax cross subdomain requirement
try {
    document.domain = document.domain.replace(/.*?(\w+\.\w+)$/, '$1')
} catch (e) {}

/**
 ParseEmoteOutput - 

 Requirement:
		blank.html, a minimal HTML file used for popup window permission clearance
		
 Method:
		Parse( [ parsable message string ], [ associative array of options, must include access_level ] )

 @constructor
 @example
		var g_oParseEmoteOutput = new ParseEmoteOutput();
		var sRawMessage = "hi, how are you! #~e,1,)~#";
		var nUserAccessLevel = 2;
		var sParsedMessage = g_oParseEmoteOutput.Parse( sRawMessage, { access_level: nUserAccessLevel });
		alert( sParsedMessage );
 */
function ParseEmoteOutput() {}
ParseEmoteOutput.prototype.Parse = function (sMessage, hParams) {
    hParams = hParams || {}

    const image_url =
        (hParams && hParams.image_url) ||
        (typeof g_hPlatform === 'object' && g_hPlatform.image_url) ||
        'https://img.mf' + 'cimg.com/'

    // image parsing
    const bDarkMode = !!hParams.darkMode
    let nParseLimit = 0

    const bBasicEmotesOnly = hParams['basic_emotes_only'] ? true : false

    if (typeof hParams['access_level'] === 'undefined')
        hParams['access_level'] = 2

    let bAllowUserImages = true
    if (
        typeof hParams['allow_user_images'] !== 'undefined' &&
        hParams['allow_user_images'] == 0
    )
        bAllowUserImages = false

    let bUseSmartImgTags = false
    if (typeof hParams['use_smart_image_tags'] !== 'undefined')
        bUseSmartImgTags = hParams['use_smart_image_tags'] ? true : false

    oImgRegExPattern =
        /#~(e|c|u|ue),(\w+)(\.?)(jpeg|jpg|gif|png)?,([\w\-\:\);\(\]\=\$\?\*]{0,48}),?(\d*),?(\d*)~#/
    oImgRegExPattern = /#~(c),(\w+)(\.)(\w{3})~#/

    const aRegExPatterns = [
        /#~(e|c|u|ue),(\w+)(\.?)(jpeg|jpg|gif|png)?,([\w\-\:\);\(\]\=\$\?\*]{0,48}),?(\d*),?(\d*)~#/,
        /#~(c),(\w+)(\.)(\w{3})~#/,
    ]

    const aData = ['']
    let nCx = 1
    for (let a = 0; a < aRegExPatterns.length; a++) {
        var oImgRegExPattern = aRegExPatterns[a]

        let re = []
        while ((re = sMessage.match(oImgRegExPattern)) && nParseLimit < 10) {
            const sType = re[1] || ''
            const sFileCode = re[2] || ''
            const sDot = re[3] || ''
            const sFileExtension = re[4] || ''
            const sShortcut = re[5] || ''
            let nWidth = re[6] || ''
            let nHeight = re[7] || ''

            const nOriginalSize = { width: nWidth, height: nHeight }

            let sImg = sFileCode + sDot + sFileExtension
            const sMediumImg = sFileCode + sDot + '200x.' + sFileExtension
            const sSmallImg = sFileCode + sDot + 'x50.' + sFileExtension

            let sTypeDir = sType

            const bError = false
            if (
                (nWidth > 0 && !(nHeight > 0)) ||
                (nHeight > 0 && !(nWidth > 0))
            ) {
                nWidth = null
                nHeight = null
            }

            if (sType === 'e') {
                sImg += '.gif'
            } else if (sType === 'ue') {
                sTypeDir = 'u'
            }

            const sDark = sType == 'e' && bDarkMode ? 'dark/' : ''

            let sImgPath = 'chat_images/' + sTypeDir + '/' + sDark
            sImgPath = image_url + sImgPath

            if (sType !== 'e') {
                sImgPath += sImg.substring(0, 2) + '/'
            }

            let sSrc = ''
            let sExtra = ''
            let sTitle = sType !== 'c' ? ':' + sShortcut : ''
            let bDownSize = false
            if (
                bAllowUserImages === false ||
                (bBasicEmotesOnly && sType !== 'e')
            ) {
                sSrc = image_url + 'files/images/emoticons/588.gif'

                sExtra =
                    ' data-src="' +
                    sImgPath +
                    sSmallImg +
                    '" ' +
                    ' data-large-img="' +
                    sImgPath +
                    sImg +
                    '" ' +
                    ' class="chat_image_placeholder" '

                nWidth = null
                nHeight = null
            } else if (
                sType === 'e' ||
                (sType === 'ue' && hParams['access_level'] > 0)
            ) {
                sSrc = sImgPath + sImg
                if (nWidth > 1024 || nHeight > 1024) {
                    bDownSize = true
                }
            } else if (
                hParams['access_level'] > 1 ||
                hParams['offline'] ||
                hParams['access_level'] === -1
            ) {
                sSrc = sImgPath + sSmallImg
                bDownSize = true
            } else {
                sMessage = sMessage.replace(
                    oImgRegExPattern,
                    '<i' +
                        'mg src="' +
                        image_url +
                        "chat_images/e/1000.gif\" title='premium image'>",
                )
                sTitle = 'premium image'
            }

            var sOnClickCode
            if (sType === 'e') {
                sOnClickCode = ''
            } else if (hParams['onclick_code']) {
                sOnClickCode = hParams['onclick_code']
                // Replace with functions, so a $ in the shortcut is never
                // read as a replacement pattern ($', $& and the like)
                sOnClickCode = sOnClickCode.replace(
                    /%image%/,
                    () => sImgPath + sImg,
                )
                sOnClickCode = sOnClickCode.replace(/%shortcut%/, () => sTitle)
            } else {
                sOnClickCode =
                    " ParseEmoteOutput.prototype.Popup('" +
                    sImgPath +
                    sImg +
                    "'); "
            }

            if (
                (sType === 'e' || sType === 'ue') &&
                (nWidth > 100 || nHeight > 100)
            ) {
                bDownSize = true
            }

            if (bDownSize && (nWidth || nHeight)) {
                const size = this.determineThumbnailSize('x50', nWidth, nHeight)
                nWidth = size['width']
                nHeight = size['height']
            }

            // hack - discard WxH if the values are both 1
            if (nWidth === 1 && nHeight === 1) {
                nHeight = false
                nWidth = false
            }

            const nThumbnailSize = { width: nWidth, height: nHeight }

            if (hParams.output_type === 'array') {
                aData.push({
                    src: sSrc,
                    thumbnail_src: {
                        small: sSmallImg,
                        medium: sMediumImg,
                    },
                    size: nOriginalSize,
                    thumbnail_size: nThumbnailSize,
                    shortcut: sShortcut,
                    type: sType,
                })

                sMessage = sMessage.replace(oImgRegExPattern, ':' + nCx + ':')
            } else {
                // A function, not a string: the tag holds the sender's
                // shortcut, and a $ in it would otherwise be read as a
                // replacement pattern ($' pastes in the rest of the message)
                const sImgTag =
                    '<' +
                    (bUseSmartImgTags ? 'smart' : '') +
                    'i' +
                    'mg src="' +
                    sSrc +
                    '" ' +
                    (nWidth ? ' width=' + nWidth : '') +
                    (nHeight ? ' height=' + nHeight : '') +
                    (hParams['onload_code']
                        ? ' style="margin-top:30px;width: 25px;height: 25px" onLoad="this.style.marginTop=\'0px\';' +
                          hParams['onload_code'] +
                          '"'
                        : '') +
                    (sOnClickCode ? ' onClick="' + sOnClickCode + '"' : '') +
                    (sTitle
                        ? " title='" +
                          sTitle.replace(/'/g, '').replace('$', '&#36;') +
                          "'"
                        : '') +
                    sExtra +
                    ' onMouseover="if( this.height >= 50 ){ this.style.cursor=\'pointer\'; }" ' +
                    ' style="max-width: 100%" >'
                sMessage = sMessage.replace(oImgRegExPattern, () => sImgTag)
            }

            nParseLimit++
            nCx++
        }
    }

    // all ProcessCard methods to be removed from this obj after 2/15/19
    //	sMessage = this.ProcessCard(sMessage);

    if (hParams.output_type === 'array') {
        aData[0] = sMessage
        return aData
    } else {
        return sMessage
    }
}

ParseEmoteOutput.prototype.ProcessCard = function (sMessage) {
    let aMatches
    let hParams = {}
    let hTpl = {}

    if (
        (aMatches = sMessage.match(
            /(https:\/\/[\w\.]+\/[^\s"']*?).MFCjson=([^\s"']+)/,
        ))
    ) {
        hParams = JSON.parse(decodeURIComponent(aMatches[2])) || {}
        hParams.url = aMatches[1]
    }

    if (
        hParams.url &&
        (aMatches = sMessage.match(
            /(https:\/\/share\.myfreecams\.com\/)(\w+)(\/\w+)/,
        ))
    ) {
        hParams.url = aMatches[1] + aMatches[2] + aMatches[3]

        hParams.type = aMatches[2]
        hTpl = this.MfcShare_CardTpl(hParams)

        sMessage = sMessage.replace(
            /(https:\/\/share\.myfreecams\.com\/[^\?]+)\?([-a-zA-Z0-9@:%_\+.~#?&//=]+)/g,
            '$1',
        )
    } else if (hParams.url) {
        aDomain = hParams.url.match(/(\w+\.\w{2,3})\//)
        hParams.domain = aDomain[1]

        hTpl = this.CardTpl(hParams)

        sMessage = sMessage.replace(
            /(https:\/\/[\w\.]+\/[^\s"']*?).MFC=1&[-a-zA-Z0-9@:%_\+.~#?&//=]+/g,
            '$1',
        )
    }

    if (hTpl.html && typeof hTpl.params === 'object') {
        for (const key in hTpl.params) {
            if (
                typeof hTpl.params[key] !== 'string' &&
                typeof hTpl.params[key] !== 'number'
            ) {
                continue
            }
            const regex = new RegExp('{{' + key + '}}', 'g')
            hTpl.html = hTpl.html.replace(regex, hTpl.params[key])
        }

        hTpl.html = hTpl.html.replace(/{{\s*\w+\s*}}/g, '')
    }

    return sMessage + (hTpl.html || '')
}
ParseEmoteOutput.prototype.CardTpl = function (hParams) {
    const hTpl = {}
    hTpl.params = hParams
    hTpl.html =
        '\
		<div class=TwitterCard_inChat>\
		<table border=0>\
		 <tr>\
		  <td class=TwitterCard_inChat_img_td>\
			<a href="{{url}}" target=_blank>\
			<img onError="this.style.display=\'none\';" class=TwitterCard_inChat_img src="{{image}}">\
			</a>\
		  </td>\
		  <td class=TwitterCard_inChat_content>\
			<a href="{{url}}" target=_blank>\
				<span class=TwitterCard_inChat_title> {{title}} </span>\
			</a>\
			<a class=TwitterCard_inChat_domain href="{{url}}"> {{domain}} </a>\
		  </td>\
		 </tr>\
		</table>\
		</div>\
	'

    return hTpl
}
ParseEmoteOutput.prototype.MfcShare_CardTpl = function (hParams) {
    hParams = hParams || {}

    hParams.title = hParams.ti
    hParams.token_amount = hParams.to
    hParams.username = hParams.un
    hParams.user_id = hParams.ui

    hParams.mfcshare = 1

    const ShareTypeMap = {
        a: 'Album',
        s: 'Item',
        c: 'Collection',
        g: 'Goal',
        m: 'Club',
    }

    const url_domain = document.domain.replace(/.*?(\w+\.\w+)$/, '$1')

    hParams.user_name =
        hParams.user_name && hParams.user_name.replace(/[^\w]/g, '')
    hParams.user_name_url =
        hParams.user_name &&
        'https://share.' +
            url_domain +
            '/' +
            hParams.user_name.replace(/[^\w]/g, '')
    hParams.type = ShareTypeMap[hParams.type] || ''
    hParams.title = (hParams.title && hParams.title.replace(/[<]/g, '')) || ''
    hParams.image =
        (hParams.image &&
            hParams.image.replace(/"/g, '').replace(/\?.*/, '')) ||
        ''

    if (hParams.token_amount) {
        hParams.token_amount =
            ' / ' + hParams.token_amount.replace(/[<]/g, '') + ' Tokens'
    }

    const image_url =
        (hParams && hParams.image_url) ||
        (g_hPlatform && g_hPlatform.image_url) ||
        'https://img.mf' + 'cimg.com'
    hParams.logo = image_url + 'files/images/misc/MFCShare.svg'

    const hTpl = {}
    hTpl.params = hParams
    hTpl.html =
        '\
		<div class=MFCShare_inChat>\
		<table border=0>\
		 <tr>\
		  <td class=>\
			<a href="{{url}}" target=_blank>\
			<img onError="this.style.display=\'none\';" class=MFCShare_inChat_img src="{{image}}">\
			</a>\
		  </td>\
		  <td class=MFCShare_inChat_content>\
			<a href="{{user_name_url}}" target=_blank>\
				<div class=MFCShare_inChat_user_name> {{user_name}} on </div>\
			</a>\
			<a href="{{url}}" target=_blank>\
				<span class=MFCShare_inChat_type> {{type}} </span>\
			</a>\
			<a href="{{url}}" target=_blank>\
				<span class=MFCShare_inChat_title> {{title}} </span>\
			</a>\
			<a href="{{url}}" target=_blank>\
				<span class=MFCShare_inChat_token_amount> {{token_amount}} </span>\
			</a>\
			<a href=https://share.' +
        url_domain +
        '/>\
				<img class=MFCShare_inChat_logo onError="this.style.display=\'none\';" src="{{logo}}" target=_blank>\
			</a>\
		  </td>\
		 </tr>\
		</table>\
		</div>\
	'

    return hTpl
}

ParseEmoteOutput.prototype.ParseQueryString = function (queryString) {
    if (typeof queryString !== 'string') {
        return queryString
    }

    const query = {}
    const pairs = (
        queryString[0] === '?' ? queryString.substr(1) : queryString
    ).split('&')
    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=')
        try {
            query[decodeURIComponent(pair[0])] = decodeURIComponent(
                pair[1] || '',
            )
        } catch (e) {
            console.log(e)
        }
    }
    return query
}

ParseEmoteOutput.prototype.Popup = function (sImgUrl) {
    const oWin = window.open(
        'blank.html',
        '_blank',
        'status=0,toolbar=0,height=10,width=10',
    )
    oWin.document.write(
        '\
		<ht' +
            'ml>\
		<bo' +
            'dy style=margin:0px;>\
		<im' +
            'g\
			src=' +
            sImgUrl +
            '\
			onLoad=" window.resizeTo(this.width,this.height+25); "\
			onClick=" window.close(); "\
		>\
		</bo' +
            'dy>\
		</ht' +
            'ml>\
	',
    )
}

ParseEmoteOutput.prototype.image_sizes = [
    { width: 0, height: 0, file: '' }, // Original file, don't resize
    { width: 500, height: 50, file: 'x50' }, // 500x50 or smaller, keeping aspect ratio
    { width: 300, height: 0, file: '200x' }, // width 300 or smaller, keeping aspect ratio
    { width: 0, height: 120, file: 'x120' }, // height 120 or smaller, keeping aspect ratio
]

ParseEmoteOutput.prototype.determineThumbnailSize = function (
    thumbnail_code,
    image_width,
    image_height,
) {
    let rules
    for (let a = 0; a < ParseEmoteOutput.prototype.image_sizes.length; a++) {
        const prof = ParseEmoteOutput.prototype.image_sizes[a]
        if (prof['file'] == thumbnail_code) {
            rules = prof
        }
    }

    if (!rules) {
        return { width: image_width, height: image_height }
    }

    if (rules['height'] && image_height > rules['height']) {
        var changeRatio = rules['height'] / image_height
        image_height = rules['height']
        image_width = Math.ceil(changeRatio * image_width)
    }

    if (rules['width'] && image_width > rules['width']) {
        var changeRatio = rules['width'] / image_width
        image_width = rules['width']
        image_height = Math.ceil(changeRatio * image_height)
    }

    if (!image_width) {
        image_width = 1
    }
    if (!image_height) {
        image_height = 1
    }

    return { width: image_width, height: image_height }
}

export default ParseEmoteOutput
